import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ListUser } from './internalComponents/ListUser';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { UserFilter, FiltreUserType, FieldSort } from './internalComponents/Filter';

interface Props {
}

interface State {
    filtreUserType: FiltreUserType;
    fieldSort: FieldSort;
}

/**
 * Ce composant permet d'afficher la page de la liste des utilisateurs
 */
export class UserListPage extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            filtreUserType: FiltreUserType.TOUS,
            fieldSort: FieldSort.NOM_ASC,
        };
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <div>
                    <UserFilter
                        userTypeFilter={this.state.filtreUserType}
                        setUserTypeFilter={
                            (t: FiltreUserType) => {
                                this.setState({filtreUserType: t});
                            }
                        }
                        userFieldSort={this.state.fieldSort}
                        setFieldSort={
                            (t: FieldSort) => {
                                this.setState({fieldSort: t});
                            }
                        }
                    />
                    <ListUser 
                        userFilter={this.state.filtreUserType}
                        fieldSort={this.state.fieldSort}
                    />
                </div>
            </PageChorinitia>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/UserListPage/UserListPage.tsx